import { makeAuthHeaders } from "../oauth/auth";

export const fetchChangeLog = async () => {
  try {
    let headers = await makeAuthHeaders();

    let response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/dcm/changelog/list`,
      {
        method: "GET",
        headers
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("UNAUTHORIZED");
      }

      let body = await response.json();
      throw new Error(body.message);
    }

    return response.json();
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchChangeLogExportByDateRange = async (ids, dateRange) => {
  try {
    let headers = await makeAuthHeaders();

    headers["Content-Type"] = "application/json";

    let response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/dcm/changelog/users/export`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({ profileIds: ids, dateRange })
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("UNAUTHORIZED");
      }

      let body = await response.json();
      throw new Error(body.message);
    }

    return response.json();
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const searchChangeLog = async (ids, searchString) => {
  try {
    let headers = await makeAuthHeaders();

    headers["Content-Type"] = "application/json";

    let response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/dcm/changelog/search`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({ profileIds: ids, searchString })
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("UNAUTHORIZED");
      }

      let body = await response.json();
      throw new Error(body.message);
    }

    return response.json();
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// --- Unfiltered endpoints for Master Admins ---

export const fetchChangeLogAll = async (pageToken = null) => {
  try {
    let headers = await makeAuthHeaders();
    headers["Content-Type"] = "application/json";

    let response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/dcm/changelog/all/list`,
      {
        method: "POST",
        headers,
        body: JSON.stringify(pageToken ? { pageToken } : {})
      }
    );

    if (!response.ok) {
      if (response.status === 401) throw new Error("UNAUTHORIZED");
      let body = await response.json();
      throw new Error(body.message);
    }

    return response.json();
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchChangeLogExportAllByDateRange = async (dateRange) => {
  try {
    let headers = await makeAuthHeaders();
    headers["Content-Type"] = "application/json";

    let response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/dcm/changelog/all/export`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({ dateRange })
      }
    );

    if (!response.ok) {
      if (response.status === 401) throw new Error("UNAUTHORIZED");
      let body = await response.json();
      throw new Error(body.message);
    }

    return response.json();
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const searchChangeLogAll = async (searchString) => {
  try {
    let headers = await makeAuthHeaders();
    headers["Content-Type"] = "application/json";

    let response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/dcm/changelog/all/search`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({ searchString })
      }
    );

    if (!response.ok) {
      if (response.status === 401) throw new Error("UNAUTHORIZED");
      let body = await response.json();
      throw new Error(body.message);
    }

    return response.json();
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchAllAdvertisers = async () => {
  try {
    let headers = await makeAuthHeaders();

    let response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/dcm/advertisers/all`,
      {
        method: "GET",
        headers
      }
    );

    if (!response.ok) {
      if (response.status === 401) throw new Error("UNAUTHORIZED");
      let body = await response.json();
      throw new Error(body.message);
    }

    return response.json();
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchChangeLogByIds = async (ids, pageToken = null) => {
  try {
    let headers = await makeAuthHeaders();

    headers["Content-Type"] = "application/json";

    let response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/dcm/changelog/users/list`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({ profileIds: ids, ...(pageToken ? { pageToken } : {}) })
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("UNAUTHORIZED");
      }

      let body = await response.json();
      throw new Error(body.message);
    }

    return response.json();
  } catch (e) {
    console.log(e);
    throw e;
  }
};
